import { useEffect, useState } from 'react';
import { ClockCounterClockwise, Info } from '@phosphor-icons/react';
import { nasApi, fmtDate } from './nasApi';
import { NAS_I18N } from './nasI18n';

const KIND_LABEL = {
  indexed: '取り込み', skipped: 'スキップ', error: 'エラー',
  missing: '見つからない', updated: '更新', discovered: '検出',
};

// Recent Changes tab — read-only journal from dms_nas_events.
export default function NasArchiveChanges() {
  const [events, setEvents] = useState(null);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    nasApi.changes().then((r) => setEvents(r.events || []))
      .catch((e) => { if (e?.response?.status === 404) setDisabled(true); else setEvents([]); });
  }, []);

  if (disabled) {
    return (
      <div className="rounded-lg border border-zinc-200 bg-zinc-50 p-6 text-center" data-testid="nas-changes-disabled">
        <Info size={22} className="mx-auto text-zinc-400 mb-2" />
        <p className="text-sm font-medium text-zinc-700">{NAS_I18N.disabled_title}</p>
        <p className="text-sm text-zinc-500 mt-1">{NAS_I18N.disabled_hint}</p>
      </div>
    );
  }

  return (
    <div className="max-w-[820px]" data-testid="nas-changes">
      <p className="text-xs text-zinc-400 mb-3 inline-flex items-center gap-1">
        <Info size={12} /> スキャンと突合の記録です（読み取り専用）。自動ウォッチャーは本フェーズでは無効です。
      </p>
      {events === null ? (
        <p className="text-sm text-zinc-400 py-10 text-center">読み込み中…</p>
      ) : events.length === 0 ? (
        <p className="text-sm text-zinc-400 py-10 text-center" data-testid="nas-changes-empty">まだ記録はありません</p>
      ) : (
        <ul className="space-y-1.5">
          {events.map((e) => (
            <li key={e.id} className="flex items-start gap-2 rounded-md border border-zinc-200 bg-white px-3 py-2"
              data-testid={`nas-change-${e.id}`}>
              <ClockCounterClockwise size={14} className="text-zinc-400 mt-0.5 shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-sm text-zinc-800 truncate">
                  <span className="font-medium">{KIND_LABEL[e.kind] || e.kind}</span>
                  {e.name ? ` — ${e.name}` : ''}
                </p>
                {e.message && <p className="text-xs text-zinc-500 truncate">{e.message}</p>}
              </div>
              <span className="text-xs text-zinc-400 tabular-nums shrink-0">{fmtDate(e.at)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
